<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <p>Device: 850002000027</p>
            </v-col>
            <v-col cols="12">
                <v-btn @click="publishContMessage">Publish Continuous Messages {{ index }}</v-btn>
            </v-col>
            <v-col cols="12">
                <v-btn @click="publishMessage">Publish Single Messages {{ index }}</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import {onBeforeUnmount, onMounted, ref} from "vue";
import pahoMqttClient from '@/plugins/mqttClient';
import {send} from "@/composables/apiClient";

const route = [];
const index = ref(0);
const imageUrl = ref(null);

const getAssetPhoto = ((asset) => {
    send('get', `assets/${asset}/photo-url`)
        .then((response) => {
            if (response.data.success) {
                imageUrl.value = response.data.data.url;
            }
        })
        .catch((error) => {
            console.log(error)
        })
})

onMounted(() => {
    getAssetPhoto(111)
    const generateZigZagRoute = (startLat, startLng, steps, variance) => {
        route.push({lat: startLat, lng: startLng});

        for (let i = 1; i <= steps; i++) {
            let last = route[i - 1];
            route.push({
                lat: last.lat + (Math.random() * variance - variance / 2),
                lng: last.lng + (Math.random() * variance - variance / 2)
            });
        }
        return route;
    };
    generateZigZagRoute(40.730610, -73.935242, 10, 0.01);

    pahoMqttClient.connect(process.env.VUE_APP_MQTT_URL, 'dev', {
        'username': process.env.VUE_APP_MQTT_USERNAME,
        'password': process.env.VUE_APP_MQTT_PASSWORD,
    });
})
const publishContMessage = () => {
    index.value = 0;
    let intervalId = setInterval(() => {
        if (index.value < route.length) {
            publishMessage();
        } else {
            clearInterval(intervalId);
        }
    }, 2 * 1000);
};

const publishMessage = () => {
    if (index.value >= route.length) {
        index.value = 0;
    }
    const message = {
        "gps_speed": 80,
        "message_type": index.value === 0 ? 2 : (index.value === route.length - 1 ? 4 : 3),
        "last_message_received": new Date().toISOString(),
        "last_updated_ago": "0 seconds ago",
        "lat": route[index.value].lat,
        "lng": route[index.value].lng,
        "valid": true,
        "voltage1": Math.floor(Math.random() * (90 - 30 + 1) + 30),
        "voltage2": Math.floor(Math.random() * (90 - 30 + 1) + 30),
        "heading": Math.floor(Math.random() * (360 - 30 + 1) + 30),
        'signal_bars': 5,
        'battery_bars': 5,
        "driver": {
            "driver_first_name": "John",
            "driver_last_name": "Smith",
            "driver_photo": "https://avatar.iran.liara.run/public"
        },
        "trip": {
            "avg_speed": Math.floor(Math.random() * (90 - 30 + 1) + 30),
            "distance": 0,
            "duration": 0,
            "end_location": {
                "lat": route[index.value].lat,
                "lon": route[index.value].lng
            },
            "id": 116716,
            "max_speed": 80,
            "start_location": {
                "lat": route[0].lat,
                "lon": route[0].lng
            },
            "time": new Date().toISOString(),
            "from": `${route[0]['lat']},${route[0]['lng']}`,
            "to": `${route[index.value]['lat']},${route[index.value]['lng']}`
        },
        "trip_route": {
            "id": index.value + 1,
            "trip_id": 116716,
            "latitude": route[index.value].lat,
            "longitude": route[index.value].lng,
            "receive_time": new Date().toISOString(),
            "voltage1": Math.floor(Math.random() * (90 - 30 + 1) + 30),
            "voltage2": Math.floor(Math.random() * (90 - 30 + 1) + 30),
            "message_type": index.value === 0 ? 2 : (index.value === route.length - 1 ? 4 : 3),
        }
    };

    setTimeout(() => {
        pahoMqttClient.publish('d/850002000027', JSON.stringify(message));
        pahoMqttClient.publish('d/850002000104', JSON.stringify(message));
    }, 2000)

    index.value++; // Move to the next point
};
onBeforeUnmount(() => {
    // Disconnect MQTT when the component is destroyed
    pahoMqttClient.disconnect();
});

</script>

